import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';

import './style.scss';

/**
 * 
 * @param {string} photo Member photo image
 * @param {string} initials Member initials. Displayed if there is no photo
 * @param {string} size Size of photo: xxl(244px), xl(192px), lg(84px), md(48px), sm(36px), auto. Default: sm
 * @param {number} customSize Custom photo size
 * @param {function} onClick Callback on image click
 * @param {function} onError Callback on iomage load error
 * @returns {ReactComponent}
 */
const MemberPhoto = ({photo, size = 'sm', initials = '', customSize = 0, isPdf = false, onClick, onError}) => {
    const [isLoaded, setLoaded] = useState(false);
    const [memberPhoto, setMemberPhoto] = useState(null);
    const [initialsSize, setInitialsSize] = useState('');
    const photoSize = customSize > 0 ? {width: customSize, height: customSize} : {};
    const memberPhotoRef = useRef(null);

    useEffect(() => {
        setMemberPhoto(photo || '');
    }, [photo]);

    useEffect(() => {
        if (!memberPhotoRef.current) return;

        const { width } = memberPhotoRef.current.getBoundingClientRect();
        setInitialsSize(!!width ? `${width / 4}px` : '10px');
    }, []);

    function handleLoadError(e) {
        setLoaded(false);
        setMemberPhoto('');
        if (!!onError && typeof onError === 'function') onError('Load image error', e);
    }

    return (
        <div
            ref={memberPhotoRef}
            className={`member-photo ${!customSize ? `member-photo--${size}` : ''} ${!memberPhoto ? 'member-photo--no-photo' : ''}`}
            style={{
                cursor: typeof onClick === 'function' ? 'pointer' : 'default',
                background: photo ? 'none' : 'var(--app-additional-color-2)',
                ...photoSize,
            }}
            onClick={onClick}
        >
            {
                !!memberPhoto
                ? <motion.img
                    initial={{
                        opacity: isPdf ? 1 : 0,
                    }}
                    animate={{
                        opacity: isPdf || isLoaded ? 1 : 0,
                    }}
                    transition={{
                        duration: isPdf ? 0 : 1.3,
                    }}
                    src={memberPhoto}
                    alt=""
                    onLoad={() => setLoaded(true)}
                    onError={(e) => handleLoadError(e)}
                />
                : <motion.div
                    initial={{
                        opacity: 0,
                    }}
                    animate={{
                        opacity: 1,
                    }}
                    transition={{
                        duration: 0.1,
                    }}
                >
                    <p
                        className="member-photo__initials"
                        style={{
                            fontSize: initialsSize,
                        }}
                    >
                        {initials}
                    </p>
                </motion.div>
            }
        </div>
    )
}

export default MemberPhoto;
